import { DEFAULT_COLORS, DEFAULT_PADDING } from '@bpchart/d3-modules/defaults'
import { DEFAULT_AXIS_COLUMN_TWO_SCALES_PARAMS } from '../axisColumnTwoScales'
import { DEFAULT_GRAPHIC_COLUMN_LINE_PARAMS } from '../graphicColumnLine'
import { DEFAULT_GRAPHIC_DOT_PARAMS } from '../graphicDot'
import { DEFAULT_GRAPHIC_COLUMN_BAR_PARAMS } from '../graphicColumnBar'
import { DEFAULT_GRAPHIC_COLUMN_BAR_GROUP_PARAMS } from '../graphicColumnBarGroup'
import { DEFAULT_GRAPHIC_COLUMN_BAR_STACK_PARAMS } from '../graphicColumnBarStack'
import { Params, ChartColumnTwoScalesBarAndLineParams, ChartColumnTwoScalesBarGroupAndLineParams, ChartColumnTwoScalesBarStackAndLineParams, ChartColumnTwoScalesLineParams } from './types'

const reversedDefaultColor = DEFAULT_COLORS.map(d => d).reverse()

export const DEFAULT_CHART_COLUMN_TWO_SCALES_PARAMS: Params = {
  axisColumnTwoScales: DEFAULT_AXIS_COLUMN_TWO_SCALES_PARAMS,
  tooltipAside: {
    templateHtml: (data) => {
      if (data.y1.groupData && data.y2.groupData) {
        return `
          <div>
            <div>${data.xLabel}</div>
            <div>${data.y1.groupData.map((d: any) => d.value).join(',')}</div>          
            <div>${data.y2.groupData.map((d: any) => d.value).join(',')}</div>          
          </div>
        `
      }
      return ''
    },
  },
  y1Colors: DEFAULT_COLORS,
  y2Colors: reversedDefaultColor, // 顏色和bar區隔開來
  padding: DEFAULT_PADDING,
  highlightTarget: 'datum',
  highlightDatumId: '',
  highlightItemId: '',
  highlightGroupId: '',
  showAuxLine: false,
  y1DomainMinValue: 0,
  y1DomainMaxValue: undefined,
  y1DomainMinRange: undefined,
  y1DomainMaxRange: 0.95,
  y2DomainMinValue: 0,
  y2DomainMaxValue: undefined,
  y2DomainMinRange: undefined,
  y2DomainMaxRange: 0.95,
  showDot: 'hover'
}

export const DEFAULT_CHART_COLUMN_TWO_SCALES_BAR_AND_LINE_PARAMS: ChartColumnTwoScalesBarAndLineParams = {
  ...DEFAULT_CHART_COLUMN_TWO_SCALES_PARAMS,
  graphicColumnLine: DEFAULT_GRAPHIC_COLUMN_LINE_PARAMS,
  graphicDot: DEFAULT_GRAPHIC_DOT_PARAMS,
  graphicColumnBar: DEFAULT_GRAPHIC_COLUMN_BAR_PARAMS
}

export const DEFAULT_CHART_COLUMN_TWO_SCALES_BAR_GROUP_AND_LINE_PARAMS: ChartColumnTwoScalesBarGroupAndLineParams = {
  ...DEFAULT_CHART_COLUMN_TWO_SCALES_PARAMS,
  graphicColumnLine: DEFAULT_GRAPHIC_COLUMN_LINE_PARAMS,
  graphicDot: DEFAULT_GRAPHIC_DOT_PARAMS,
  graphicColumnBarGroup: DEFAULT_GRAPHIC_COLUMN_BAR_GROUP_PARAMS
}

export const DEFAULT_CHART_COLUMN_TWO_SCALES_BAR_STACK_AND_LINE_PARAMS: ChartColumnTwoScalesBarStackAndLineParams = {
  ...DEFAULT_CHART_COLUMN_TWO_SCALES_PARAMS,
  graphicColumnLine: DEFAULT_GRAPHIC_COLUMN_LINE_PARAMS,
  graphicDot: DEFAULT_GRAPHIC_DOT_PARAMS,
  graphicColumnBarStack: DEFAULT_GRAPHIC_COLUMN_BAR_STACK_PARAMS
}

export const DEFAULT_CHART_COLUMN_TWO_SCALES_LINE_PARAMS: ChartColumnTwoScalesLineParams = {
  ...DEFAULT_CHART_COLUMN_TWO_SCALES_PARAMS,
  graphicColumnLine: DEFAULT_GRAPHIC_COLUMN_LINE_PARAMS,
  graphicDot: DEFAULT_GRAPHIC_DOT_PARAMS,
}
